export default "__VITE_ASSET__Bae621wh__"